import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormField, TextareaField } from '../../../molecules'
import type { ApplicationTabProps } from '../applicationFormTypes'

// The thumbnail is not edited by this form today, so it has no field here
export const ApplicationGeneralTab = memo(
  ({ values, errors, onChange, skeleton }: ApplicationTabProps) => {
    const { t } = useTranslation('admin-mobifull')
    return (
      <>
        <FormField
          skeleton={skeleton}
          id="app-name"
          label={t('applications.form.nameLabel')}
          name="name"
          value={values.name}
          onChange={e => onChange('name', e.target.value)}
          error={errors.name}
          required
        />
        <FormField
          skeleton={skeleton}
          id="app-livestream"
          label={t('applications.form.livestreamPresetLabel')}
          name="livestream_preset"
          value={values.livestream}
          onChange={e => onChange('livestream', e.target.value)}
        />
        <TextareaField
          skeleton={skeleton}
          id="app-observations"
          label={t('applications.form.observationsLabel')}
          name="observations"
          value={values.observations}
          onChange={e => onChange('observations', e.target.value)}
        />
      </>
    )
  },
)

ApplicationGeneralTab.displayName = 'ApplicationGeneralTab'
